import { render, staticRenderFns } from "./ConstructiveDesign.vue?vue&type=template&id=8cbe31ac&scoped=true&"
import script from "./ConstructiveDesign.vue?vue&type=script&lang=js&"
export * from "./ConstructiveDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe31ac",
  null
  
)

export default component.exports